import { useSelector } from "react-redux";

const EMPTY_OBJ = {};
const usePreBiAssistance = () => {
    const supportWidget = useSelector((state) => state?.supportWidget || EMPTY_OBJ);
    const isFirstUserSession = useSelector((state) => state?.user?.isFirstUserSession || false);
    const { isModalContentSeen = false, launchNudge = false, showNudge = false } = supportWidget;
    const renderSupportNudge = !!(!isModalContentSeen && launchNudge && showNudge);
    return { renderSupportNudge, isFirstUserSession };
};

export default usePreBiAssistance;
